import {
    StoreNotesBatchAction,
    ClearNotesCacheAction,
    SetNotesLoadingAction,
    STORE_NOTES_BATCH,
    CLEAR_NOTES_CACHE,
    SET_NOTES_LOADING
} from "../actions/notes";

export interface NotesState {
    cache: {
        [cacheKey: string]: any[];
    };
    loading: {
        [cacheKey: string]: boolean;
    };
}

const initialState: NotesState = {
    cache: {},
    loading: {}
};

const notesReducer = (
    state: NotesState = initialState,
    action: StoreNotesBatchAction | ClearNotesCacheAction | SetNotesLoadingAction
): NotesState => {
    switch (action.type) {
        case STORE_NOTES_BATCH: {
            const { cacheKey, notes } = action.payload;
            
            return {
                ...state,
                cache: {
                    ...state.cache,
                    [cacheKey]: notes
                },
                loading: {
                    ...state.loading,
                    [cacheKey]: false
                }
            };
        }

        case CLEAR_NOTES_CACHE: {
            const { cacheKey } = action.payload || {};
            
            if (cacheKey) {
                const newCache = { ...state.cache };
                const newLoading = { ...state.loading };
                
                delete newCache[cacheKey];
                delete newLoading[cacheKey];
                
                return {
                    ...state,
                    cache: newCache,
                    loading: newLoading
                };
            }
            
            // Clear all cache
            return {
                cache: {},
                loading: {}
            };
        }

        case SET_NOTES_LOADING: {
            const { cacheKey, loading } = action.payload;
            
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [cacheKey]: loading
                }
            };
        }

        default:
            return state;
    }
};

export default notesReducer;

